namespace TabAurous {
    export interface ScriptUserDefinition {
        Username?: string;
        UserId?: number;
        DisplayName?: string;
        IsAdmin?: boolean;
        Permissions?: { [key: string]: boolean };
        CompanyId?: number;
        FinancialYearId?: number;
        CurrencyId?: number;
        TaxGroupId?: number;
        StartDate?: string;
        EndDate?: string;
        CompanyCode?: string;
        Locations?: number[];
        Branchs?: number[];
    }
}
